import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class SearchEventCountService {

  constructor(private http: HttpClient) { }

  async getEventCount(query) {
    try {
      // const httpOptions = {
      //   headers: new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: `jwt ${idToken}`
      //   })
      // }; 
      console.log
      let response = await this.http
        .get(`${appApiResources.getEventCount}?event_id=${query.event_id}&role_id=${query.role_id}&language_id=${query.language_id}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }
}